import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("bpj_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const asList = (data) => (Array.isArray(data) ? data : []);

export function errorText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export const money = (n) => {
  const v = Number(n ?? 0);
  return `$${v.toLocaleString("en-US", { minimumFractionDigits: Number.isInteger(v) ? 0 : 2, maximumFractionDigits: 2 })}`;
};

export async function startCheckout(items) {
  const { data } = await api.post("/payments/checkout", { items, origin_url: window.location.origin });
  if (data?.checkout_url) window.location.href = data.checkout_url;
}
